/*eslint-disable*/
import React from 'react'
import ReactDOM from 'react-dom'
import 'antd/dist/antd.min.css'

//import registerServiceWorker from './registerServiceWorker'
import Desktop from './Desktop'
import Web from './Web'

import './index.scss'
import './react-grid-layout.css'
import './react-resizable.css'

ReactDOM.render(process.env.REACT_APP_DESKTOP?<Desktop/>:<Web/>, document.getElementById('root'))
//registerServiceWorker()
